<script>
import fieldMixin from '@maison/mixins/fieldMixin';
import { useField } from '@phoenix/composables/field';
import RadioField from '@maison/components/form/fields/RadioField.vue';
import PictureLazy from '@maison/components/common/PictureLazy.vue';
import { PhxIcon } from '@phx-styleguides/iwc';

export default {
  components: {
    PhxIcon,
    PictureLazy,
    RadioField,
  },

  mixins: [fieldMixin],

  props: {
    parentId: {
      type: String,
      default: '',
    },
  },

  setup(props) {
    return useField(props);
  },
};
</script>

<template>
  <radio-field v-model="value" :attrs="field" :parent-id="parentId" extra-classes="switch--radio-product">
    <template #label>
      <div class="picture picture--full">
        <picture-lazy v-bind="field.image" />
      </div>

      <phx-icon icon="diamond" class="icon--xs switch--radio-product__icon" />
    </template>
  </radio-field>
</template>
